/*
    Action:     manipulates the URL for espn.com
    Orginator:  ben.hobden@espn.com
*/

var rootIndexToSport = {
    'nba':'basketball',
    'womenbb':'basketball',
    'sports/womenbb':'basketball',
    'ncb':'basketball',
    'nfl':'football',
    'ncf':'football',
    'nhl':'hockey',
    'mlb':'baseball',
    'atp':'tennis',
    'wtp':'tennis',
    'tennis':'tennis',
    'pga':'golf',
    'golf':'golf',
    'rpm':'racing',
    'football':'soccer',
    'soccer':'soccer',
    'rugby':'rugby',
    'college-sports':'ncaa'
};

var rootIndexToLeague = {
	'womenbb':'wnba',
	'sports/womenbb':'wnba',
	'ncf':'college-football',
	'ncb':'mens-college-basketball',
	'ncw':'womens-college-basketball',
	'tennis':'atp',
	'golf':'pga',
	'rpm':'sprint',
	'soccer':'eng.1',
	'rugby':'231649',
	'college-sports':'ncaa'
};

var Path = {

    encode: function(sBaseUrl,oParams,oDefaults) {

        /* remove any unwanted slashes */
        sBaseUrl = sBaseUrl.replace(/^\/|\/$/g,'');

        /* loop each param */
        var aUrl = [],
            sUrl = '/' + sBaseUrl;

        for (var sKey in oParams){
            if((typeof oDefaults[sKey] !== undefined && oDefaults[sKey] === oParams[sKey]) || !oParams[sKey]){
                //if(sKey === 'dir'){
                    /* special case for sort due to being tied to direction */
                //    if(typeof oParams['sort'] !== undefined && typeof oDefaults['sort'] !== undefined && oDefaults['sort'] === oParams['sort']){
                //        continue;
                //    }
                //}else{
                    continue; /* this is a default value so no need for it */
                //}
            }
            aUrl.push(sKey);
            aUrl.push(oParams[sKey]);
        }

        if(aUrl.length > 0){
            sUrl = sUrl + '/_/' + aUrl.join('/');
        }

        return sUrl;
    },

    /**
    * Deconstruct the url to determine what the user wanted
    **/
    decode: function(sPath,oParams) {

        /* remove the params */
        var aUrl    = decodeURIComponent(sPath).split(/\?(.*)/);
        var aPath   = aUrl[0].split(/\/_\//);

        /* default it to an object */
        oParams = oParams || {};

        /* remove unwanted slashes*/
        if(typeof aPath[0] !== "undefined"){
            aPath[0] = aPath[0].replace(/^\/|\/$/g,'');
        }else{
            aPath[0] = "";
        }

        if(typeof aPath[1] !== "undefined"){
            aPath[1] = aPath[1].replace(/^\/|\/$/g,'');
        }else{
            aPath[1] = "";
        }

        var aSport  = aPath[0].split(/\//);
        var aParams = aPath[1].split(/\//);
        var sRoot   = aSport[0] || null;
        var sPage   = aSport[1] || null;

        /* TODO validate sport */

        /* split the last section into key value pairs  */
        var iLim    = aParams.length;
        for (var i = 0; i < iLim; i = i+2) {
            if(aParams[i] === ''){
                continue;
            }
            oParams[aParams[i]] = aParams[i+1] || null;
        }

        /* determine sport and league */
        var sCurrSport  = this._rootToSport(sRoot)
        var sCurrLeague = oParams.league || this._sportToLeague(sCurrSport) || sRoot

        var oReturn = {
            'root': sRoot,
            'page': sPage,
            'sport': sCurrSport,
            'league': sCurrLeague,
            'isCollege':this._isCollege(sCurrLeague),
            'params': oParams
        };

        //console.log(oReturn);

        return oReturn;
    },

    _isCollege: function(sLeague){
        if (sLeague == 'ncf' || sLeague == 'ncb' || sLeague == 'ncw'){
			return true;
		}
		return false;
    },

    _rootToSport: function(sRoot){
        return rootIndexToSport[sRoot] || '';
    },

    _sportToLeague: function(sSport){
        return rootIndexToLeague[sSport];
    }

};

module.exports = Path;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/helpers/utils/path.js
 **/